import React from 'react';
import { Box, Flex, Skeleton, Text } from '@chakra-ui/react';
import {
  Bar,
  BarChart,
  CartesianGrid,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';
import { SaktiEstateMetric } from '../types';
import { SAKTI_UI_SIZE } from '../uiSizes';

interface SaktiBarChartCardProps {
  title: string;
  subtitle: string;
  data: SaktiEstateMetric[];
  loading: boolean;
}

const formatter = (value: number) => value.toLocaleString('id-ID');

const SaktiBarChartCard: React.FC<SaktiBarChartCardProps> = ({
  title,
  subtitle,
  data,
  loading,
}) => {
  return (
    <Skeleton isLoaded={!loading} borderRadius={SAKTI_UI_SIZE.cardRadius}>
      <Box
        bg="white"
        borderRadius={SAKTI_UI_SIZE.cardRadius}
        borderWidth="1px"
        borderColor="gray.200"
        p={SAKTI_UI_SIZE.cardPadding}
      >
        <Flex justify="space-between" align={{ base: 'start', md: 'center' }} mb={4}>
          <Box>
            <Text fontSize={SAKTI_UI_SIZE.chartTitle} fontWeight="bold" color="gray.800">
              {title}
            </Text>
            <Text color="gray.500" fontSize={SAKTI_UI_SIZE.chartSubtitle}>
              {subtitle}
            </Text>
          </Box>
        </Flex>

        {data.length === 0 ? (
          <Box h={SAKTI_UI_SIZE.chartHeight} display="flex" alignItems="center" justifyContent="center">
            <Text color="gray.500" fontSize="sm">
              Belum ada data untuk filter saat ini
            </Text>
          </Box>
        ) : (
          <Box h={SAKTI_UI_SIZE.chartHeight}>
            <ResponsiveContainer width="100%" height="100%">
              <BarChart data={data} margin={{ top: 8, right: 8, left: -14, bottom: 8 }}>
                <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#edf2f7" />
                <XAxis dataKey="estate" tick={{ fill: '#4a5568', fontSize: 12 }} axisLine={false} />
                <YAxis tick={{ fill: '#4a5568', fontSize: 12 }} axisLine={false} tickFormatter={formatter} />
                <Tooltip formatter={(value: number) => formatter(value)} />
                <Legend />
                <Bar dataKey="target" name="Target" fill="#E2E8E4" radius={[4, 4, 0, 0]} />
                <Bar dataKey="realisasi" name="Actual" fill="#4A5A33" radius={[4, 4, 0, 0]} />
              </BarChart>
            </ResponsiveContainer>
          </Box>
        )}
      </Box>
    </Skeleton>
  );
};

export default SaktiBarChartCard;
